import { createStore, applyMiddleware, compose } from 'redux';
import ReduxThunk from 'redux-thunk';
import { persistStore } from 'redux-persist';
import rootReducer from './reducers';
import { redirectMiddleware } from '../utils/redirectMiddleware';
import { loadSentry, sentryReduxEnhancer } from '../utils/sentry';

const isDevelopment = process.env.NODE_ENV === 'development';
const hasDevTools = isDevelopment && window.__REDUX_DEVTOOLS_EXTENSION__;

const configureStore = () => {
  const withThunk = applyMiddleware(redirectMiddleware, ReduxThunk);
  const withDevTools = hasDevTools ? compose(withThunk, window.__REDUX_DEVTOOLS_EXTENSION__()) : withThunk;
  const withSentry = loadSentry ? compose(withDevTools, sentryReduxEnhancer()) : withDevTools;

  const store = createStore(rootReducer, withSentry);
  const persistor = persistStore(store);

  return {
    store,
    persistor,
  };
};

export default configureStore;
